import React, { FC, ReactNode } from 'react';
import { Col, Row } from 'styled-bootstrap-grid';
import { QuizInner } from './quiz.styled';
import { FieldGroupDataItem } from './types';

const QuizLayout: FC<FieldGroupDataItem & { fullWidth?: boolean; children: ReactNode }> = ({ fullWidth, children }) => {
  return (
    <QuizInner {...{ fullWidth }}>
      <Row justifyContent="center">
        <Col md={fullWidth ? 12 : 7} className={'print-media-container'}>
          {children}
        </Col>
      </Row>
    </QuizInner>
  );
};

export default QuizLayout;
